export interface IShippingOptions {
  shipping_free_min_order_value_international: number;
  shipping_free_min_order_value_home: number;
  shipping_multiple_items: string;
}
